import React, { Fragment } from 'react';
import _ from 'lodash';
import { Button, Grid } from 'semantic-ui-react';
import { Filter, Main } from 'Containers';
import ReactTable from 'react-table';
import { TitledCard, LoadingPage } from 'Components';
import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';
import { PROCESS_ORDER_FORM_NAME } from 'Common/FormEnum';
import { YesNoDialog } from 'Components/dialogs/YesNoDialog';
import { PreviewProcessOrderEnum } from 'Common/FieldEnum';

const ProcessOrder = props => {
  const {
    getMainProps,
    processedOrderData,
    printOptionsValue,
    onCancelClick,
    isReadOnly,
    showCancelDialog,
    createLoading,
    onPrintPreviewClick,
    onPrintVendorSummaryClick,
    printLoading,
    onMessageClick,
  } = props;

  const printOptions = [
    { value: PreviewProcessOrderEnum.ItemCode, label: 'Item Code' },
    {
      value: PreviewProcessOrderEnum.ItemDescription,
      label: 'Item Description',
    },
  ];
  const isPrintVendorSummaryEnable = !_.some(
    processedOrderData[PreviewProcessOrderEnum.PreviewData],
    {
      [PreviewProcessOrderEnum.POWO]: 'PO',
    }
  );

  const columns = [
    {
      Header: 'PO/WO/BO/KO',
      accessor: PreviewProcessOrderEnum.POWO,
      sortable: true,
      filterable: true,
      resizable: true,
    },
    {
      Header: 'Distributor',
      accessor: PreviewProcessOrderEnum.VendorName,
      sortable: true,
      filterable: true,
      resizable: true,
      width: 400,
    },
    {
      Header: 'SiteId',
      accessor: PreviewProcessOrderEnum.SiteId,
      sortable: true,
      filterable: true,
      resizable: true,
    },
    {
      Header: 'Delivery Date',
      accessor: PreviewProcessOrderEnum.DeliveryDT,
      sortable: true,
      filterable: true,
      resizable: true,
    },
    {
      Header: 'Merchandise Cost',
      accessor: PreviewProcessOrderEnum.Cost,
      className: 'right-align',
      sortable: true,
      filterable: true,
      resizable: true,
    },
  ];

  return (
    <Fragment>
      {(createLoading || printLoading) && <LoadingPage />}
      <Filter title="Create Purchase Orders / Warehouse Orders / Back Orders / Kitchen Order" />
      <Main {...getMainProps()} isReadOnly={isReadOnly} shouldNotUsePageWidth>
        <TitledCard title={'Sort By'}>
          <Grid>
            <Grid.Row columns={3} className={'pt10'}>
              <Grid.Column width={10} verticalAlign={'bottom'}>
                <ReduxFormButtonGroup
                  options={printOptions}
                  value={printOptionsValue}
                  formName={PROCESS_ORDER_FORM_NAME}
                  fieldName={PreviewProcessOrderEnum.PrintOptions}
                  type={'button'}
                />
              </Grid.Column>
              <Grid.Column width={3}>
                <Button
                  content="Print Preview"
                  type={'button'}
                  style={{ marginLeft: 10 }}
                  onClick={onPrintPreviewClick}
                />
              </Grid.Column>
              <Grid.Column width={3}>
                <Button
                  content="Print Distributor Summary"
                  type={'button'}
                  style={{ marginLeft: 10 }}
                  disabled={isPrintVendorSummaryEnable}
                  onClick={onPrintVendorSummaryClick}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </TitledCard>
        <ReactTable
          defaultPageSize={20}
          showPageSizeOptions={true}
          minRows={0}
          data={processedOrderData.PreviewData}
          noDatatext={'No rows found'}
          resizable={false}
          className="-striped -highlight modalGrid"
          columns={[
            {
              columns: columns,
            },
          ]}
        />
        {processedOrderData[PreviewProcessOrderEnum.ExpiredBidsResult] &&
          processedOrderData[PreviewProcessOrderEnum.ExpiredBidsResult][
            PreviewProcessOrderEnum.IsWarning
          ] && (
            <div className="messageText">
              <p>
                ***One or more of these Orders contains items with invalid bid
                prices.These items will not be ordered from vendor.
              </p>
              <p>
                <div onClick={onMessageClick}>
                  <u className="cursorPointer">
                    CLICK HERE to view a report of the invalid order items
                  </u>
                </div>
              </p>
            </div>
          )}
        <YesNoDialog
          showDialog={showCancelDialog}
          title={`Cancel Process`}
          question={`Are you sure you would like to cancel the process?`}
          yesCallback={() => onCancelClick(true)}
          noCallback={() => onCancelClick(false)}
        />
      </Main>
    </Fragment>
  );
};

export default ProcessOrder;



// WEBPACK FOOTER //
// ./src/pages/inventory/manageprocessorder/components/processOrder/ProcessOrder.js